import _ from 'lodash'
import { GetterTree } from 'vuex'
import PatientState, { IPatient } from './states'
import { State } from '@/store/store'

const getters: GetterTree<PatientState, State> = {
  headerLists: (state) => {
    return state.list.column
  },
  patientOptions: (state): Array<{
    text?: string,
    value?: string,
  }> => {
    const data = _.filter(state.list.result, (item) => item.patientTypeId && (item.patientTypeId !== ''))
    return data.map((each) => {
      return {
        text: `${each.prefix ? each.prefix : ''}${each.firstname} ${each.lastname}`,
        value: each._id,
        ...each,
      }
    })
  },
  patientLists: (state) => {
    return state.list.result
  },
  patientDetail: (state) => {
    return state.patient
  },
  patientById: (state) => {
    return _.mapKeys(state.list.result, '_id')
  },
  patientTypeById: (state) => {
    return _.mapKeys(state.typeList.result, '_id')
  },
  patientName: (state) => (patientId: string) => {
    const found = _.find(state.list.result, { _id: patientId })
    return found ? `${found.prefix ? found.prefix : ''}${found.firstname} ${found.lastname}` : `(${patientId})`
  },
  patientNameByUserId: (state) => (userId: string) => {
    const found = _.find(state.list.result, { userId })
    return found ? `${found.prefix ? found.prefix : ''}${found.firstname} ${found.lastname}` : `(${userId})`
  },
  // centerId: (state) => (patientTypeId: string) => {
  //   const found = _.find(state.list.result, { patientTypeId })
  //   return found ? found.centerId : ''
  // },
  userId: (state) => (patientTypeId: string) => {
    const found = _.find(state.list.result, { patientTypeId })
    return found ? found.userId : ''
  },
  patientId: (state) => (patientTypeId: string) => {
    const found = _.find(state.list.result, { patientTypeId })
    return found ? found._id : ''
  },
  patientByUserId: (state) => (userId: string) => {
    const found = _.find(state.list.result, { userId })
    return found ? found : undefined
  },
  itemLists: (state) => {
    return state.list.result
  },
  filterLists: (state) => {
    return state.list.defaultFilter
  },
  pagination: (state) => {
    const paginationLists = {
      itemCount: state.list.itemCount,
      page: state.list.page,
      pageCount: state.list.pageCount,
    }
    return paginationLists
  },
  patientTypeLists: (state) => {
    const data = state.typeList.result
    const result: Array<{
      text?: string,
      value?: string,
    }> = []
    data.forEach((each) => {
      result.push({
        text: each.name,
        value: each._id,
      })
    })
    return result
  },
}

export default getters
